import { render, staticRenderFns } from "./InquiryDetails_Component.vue?vue&type=template&id=6c644b1c&scoped=true&"
import script from "./InquiryDetails_Component.vue?vue&type=script&lang=js&"
export * from "./InquiryDetails_Component.vue?vue&type=script&lang=js&"
import style0 from "./InquiryDetails_Component.vue?vue&type=style&index=0&id=6c644b1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c644b1c",
  null
  
)

export default component.exports